// import MonacoEditor from 'react-monaco-editor'
import React, { useState, useImperativeHandle, useContext, forwardRef, useCallback, useMemo, useRef, useEffect } from 'react';
import { Button, Modal } from 'antd';
import { PlayCircleOutlined, PauseCircleOutlined } from '@ant-design/icons';
import { WebSocketContext } from '@/components/WebSocket';
import { Terminal } from 'xterm';
import 'xterm/css/xterm.css';
import { useRequest } from 'ahooks';
import { getLog } from '@/api/cloud';
// import { WebSocketClass } from '@/utils/web-socket'

export interface LogModalProps {
  // ws?: WebSocketClass
}

export interface LogModalRef {
  open: (id: string) => void;
}

export const LogModal = forwardRef<LogModalRef, LogModalProps>((props, ref) => {
  const [id, setId] = useState('');
  const [data, setData] = useState<string[]>([]);
  const [, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { ws } = useContext(WebSocketContext);

  const { runAsync, loading } = useRequest(getLog, { manual: true });

  const handleStartLog = (id: string) => {
    runAsync({ id }).then((resp) => {
      if (resp.success) {
        setData((pre) => [...pre, resp.result]);
        if (TerminalRef.current) {
          TerminalRef.current.write(resp.result + '\r\n\x1b[33m$\x1b[0m ');
          // "\r\n\x1b[33m$\x1b[0m "
        }
      }
    });
  };

  // const handleStart = useCallback(
  //   (id: string) => {
  //     ws?.sendSync({
  //       code: 20004,
  //       data: { id, operate: 1 },
  //       success(resp) {
  //         if (resp.data.success) {
  //           setLoading(true);
  //           setData((prevValues) => {
  //             return [...prevValues, resp.data.result];
  //           });
  //           if (TerminalRef.current) {
  //             TerminalRef.current.write(resp.data.result + '\r\n\x1b[33m$\x1b[0m ');
  //             // "\r\n\x1b[33m$\x1b[0m "
  //           }
  //         }
  //       },
  //     });
  //   },
  //   [ws],
  // );

  const xtermRef = useRef(null);
  const TerminalRef = useRef<Terminal | null>(null);
  // const term = new Terminal()
  useEffect(() => {
    if (!isModalOpen) {
      TerminalRef.current = null;
      return;
    }
    setTimeout(() => {
      if (!isModalOpen || !xtermRef.current) return;
      TerminalRef.current = new Terminal({
        cols: 150,
        rows: 35,
        fontSize: 13,
      });
      TerminalRef.current.open(xtermRef.current);
      // term.write('Hello from \x1B[1;3;31mxterm.js\x1B[0m $ ')
    }, 0);
  }, [isModalOpen]);

  const logs = useMemo(() => {
    return data.map((i) => i + '\n');
  }, [data]);

  const handleStop = useCallback(() => {
    ws
      ?.send({
        code: 20004,
        data: { id, operate: 2 },
      })
      .then((resp) => {
        if (resp.data.success) {
          setLoading(false);
        }
      });
  }, [id]);

  useImperativeHandle(ref, () => {
    return {
      open(id: string) {
        setId(id);
        setIsModalOpen(true);
        // handleStart(id);
        handleStartLog(id);
      },
    };
  }, [handleStartLog]);

  return (
    <Modal
      title="云服务日志"
      width={1250}
      maskClosable={false}
      open={isModalOpen}
      destroyOnHidden
      footer={
        <>
          <Button
            type="default"
            onClick={() => {
              const content = logs.reduce((result, item) => {
                result += `${item}`;
                return result;
              });
              const a = document.createElement('a');
              a.href = 'data:text/plain;charset=utf-8,' + content;
              a.download = 'txt';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            }}
          >
            下载日志
          </Button>
          <Button
            type="primary"
            icon={loading ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
            onClick={() => {
              loading ? handleStop() : handleStartLog(id);
            }}
          >
            {loading ? '停止' : '开始'}
          </Button>
        </>
      }
      onCancel={() => {
        handleStop();
        setData(() => []);
        setIsModalOpen(false);
      }}
    >
      {/* <MonacoEditor
        height="500"
        language="javascript"
        theme="vs-dark"
        value={logs.join('')}
      ></MonacoEditor> */}
      <div ref={xtermRef}></div>
    </Modal>
  );
});

export default LogModal;
